import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ClientCarousel = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  const [animationDuration, setAnimationDuration] = useState(15); // Reduced for better visibility
  const [isReversed, setIsReversed] = useState(false);

  const clients = [
    {
      name:'zepto',
      logo:'/client-logos/zepto-logo.jpg'
    },
    {
      name:'big basket',
      logo:'/client-logos/bb_logo.png'
    },
    {
      name:'blinkit',
      logo:'/client-logos/Blinkit-yellow-rounded.png', 
    }
  ];

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => {
    setIsReversed(false);
    setAnimationDuration(prev => Math.max(prev - 3, 8));
    setTimeout(() => setAnimationDuration(15), 2000);
  };

  const handlePrev = () => {
    setIsReversed(true);
    setAnimationDuration(prev => Math.max(prev - 3, 8));
    setTimeout(() => {
      setAnimationDuration(15);
      setIsReversed(false);
    }, 2000);
  };

  const style = `
    @keyframes slide {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-${100/3}%);
      }
    }

    .logo-slide {
      animation: slide ${animationDuration}s linear infinite;
      animation-direction: ${isReversed ? 'reverse' : 'normal'};
    }

    .logo-slide:hover {
      animation-play-state: paused;
    }

    .clients-section {
      padding: 3rem 0;
      position: relative;
    }
  `;

  // Triple the items to create better seamless loop with 2 clients
  const tripleClients = [...clients, ...clients, ...clients];

  return (
    <section className="clients-section">
      <style>{style}</style>
      <div className="container position-relative">
        <div className="text-center mb-5">
          <h1 className="our-clients-heading text-black" >
            Our Clients
          </h1>
        </div>
        
        {/* Navigation Arrows - Hidden on mobile */}
        <button
          className="d-none d-md-flex carousel-control-prev"
          type="button"
          onClick={handlePrev}
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            top: '60%',
            left: '-20px',
            opacity: '1',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2
          }}
        >
          <span 
            style={{
              color: '#666',
              fontSize: '30px',
              fontWeight: 'bold',
              marginRight: '2px'
            }}
          >
            ‹
          </span>
        </button>
        
        <button
          className="d-none d-md-flex carousel-control-next"
          type="button"
          onClick={handleNext}
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            top: '60%',
            right: '-20px',
            opacity: '1',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2
          }}
        >
          <span 
            style={{
              color: '#666',
              fontSize: '30px',
              fontWeight: 'bold',
              marginLeft: '2px'
            }}
          >
            ›
          </span>
        </button>

        <div className="position-relative overflow-hidden px-md-4">
          <div 
            className="d-flex logo-slide"
            style={{
              width: 'fit-content'
            }}
          >
            {tripleClients.map((client, index) => (
              <div
                key={index}
                style={{
                  width: windowWidth < 768 ? '200px' : '250px',
                  padding: '20px',
                  flexShrink: 0
                }}
              >
                <div className="card border-0">
                  <div className="card-body d-flex align-items-center justify-content-center">
                    <img
                      src={client.logo}
                      alt={`${client.name} logo`}
                      className="img-fluid"
                      style={{
                        maxHeight: windowWidth < 768 ? '100px' : '80px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientCarousel;